<template>
  <div id="page">
    <a-row type="flex" class="row">
      <a-col flex="14rem">
        <div class="left">
          <a-menu
            mode="inline"
            v-model="selectedKeys"
            @select="onSelect"
            :openKeys.sync="openKeys"
          >
            <a-menu-item v-for="i in normal" :key="i.key"
              >{{ i.title }}
            </a-menu-item>
            <a-sub-menu key="mlAlgs">
              <span slot="title"
                ><a-icon type="control" /><span>训练</span></span
              >
              <a-menu-item v-for="i in mlAlgs" :key="i.key"
                >{{ i.title }}
              </a-menu-item>
            </a-sub-menu>
            <a-sub-menu key="algs">
              <span slot="title"
                ><a-icon type="control" /><span>计算</span></span
              >
              <a-menu-item v-for="i in algs" :key="i.key"
                >{{ i.title }}
              </a-menu-item>
            </a-sub-menu>
          </a-menu>
        </div>
      </a-col>
      <a-col flex="auto">
        <iframe
          frameborder="0"
          :srcdoc="content"
          scrolling="no"
          style="width: 850px; margin-left: 2rem"
          name="iframe2"
          onload="this.height=iframe2.document.body.scrollHeight"
        ></iframe>
      </a-col>
    </a-row>
  </div>
</template>

<script>
export default {
  data() {
    return {
      helpText: '12',
      algs: [],
      mlAlgs: [],
      normal: [],
      selectedKeys: [],
      openKeys: [],
      src: '',
      content: ''
    }
  },
  methods: {
    async changeContent() {
      const resp = await this.$http.get(
        '/help_doc/' + this.$route.params.docName
      )
      this.content = resp.data
      this.selectedKeys = [this.$route.params.docName]
    },
    onSelect(info) {
      this.selectedKeys = info.key
      this.$router.push('/help/' + info.key)
    }
  },
  watch: {
    $route() {
      this.changeContent()
      if (this.$route.params.docName.slice(0, 3) === 'iid') {
        this.openKeys = ['algs']
      }
    }
  },
  async mounted() {
    scroll(0, 0)
    const resp = await this.$http.get('/helps')
    this.algs = resp.data.algorithms
    this.mlAlgs = resp.data.ml_algorithms
    this.normal = resp.data.normal
    this.changeContent()
    if (this.$route.params.docName.slice(0, 3) === 'iid') {
      this.openKeys = ['algs']
    }
  }
}
</script>
<style lang="less" scoped>
#page {
  width: 100%;
  min-width: 1200px;
  position: absolute;
}
.left {
  margin: 0 0rem 0 1rem;
  /* padding-bottom: 1rem; */
  padding: 0.5rem 0 0.5rem 0;
  background-color: white;
}
.right {
  padding: 1rem 1rem 1rem 1rem;
  background-color: white;
  margin: 0 1rem 0 1rem;
}
</style>
